import { PageHeader, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import TfTable from './TfTable';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import TfItemForm from './TfItemForm';
import { SubHeading, Title } from 'components/RevxTypography';
import React, { useEffect, useMemo } from 'react';
import { useOrgId } from 'hooks/useOrg';
import {
  EMPTY_SCHEDULE,
  GenericSchedule,
  ScheduleTypeEnum,
} from 'domains/tfDomain';
import RevxFlexLayout from 'components/RevxFlexLayout';
import { RevxButton } from 'components/RevxButton';

const TfAdmin = () => {
  const { t } = useTranslation();
  const orgId = useOrgId();
  const dispatch = useAppDispatch();
  const curItem = useAppSelector((state) => state.tf.curItem);
  const tfConfig = useAppSelector((state) => state.tf.tfConfig);
  useEffect(() => {
    dispatch.tf.getOrgTimeframeConfig(orgId);
  }, [dispatch.tf, orgId]);
  const genericDefaults = useMemo(() => {
    return (
      tfConfig?.defaultTurnaroundTimes?.map(
        (t) =>
          ({ ...t, parentId: t.orgId, parentType: 'org' } as GenericSchedule)
      ) || []
    );
  }, [tfConfig]);
  const genericExceptions = useMemo(() => {
    return (
      tfConfig?.exceptionTurnaroundTimes?.map(
        (t) =>
          ({ ...t, parentId: t.orgId, parentType: 'org' } as GenericSchedule)
      ) || []
    );
  }, [tfConfig]);

  const onDefaultsAdd = () => {
    dispatch.tf.setState({
      curItem: {
        ...EMPTY_SCHEDULE,
        type: ScheduleTypeEnum.DEFAULT,
        parentId: orgId,
        parentType: 'org',
      },
    });
  };
  const onExceptionsAdd = () => {
    dispatch.tf.setState({
      curItem: {
        ...EMPTY_SCHEDULE,
        type: ScheduleTypeEnum.EXCEPTION,
        parentId: orgId,
        parentType: 'org',
      },
    });
  };

  return (
    <>
      <PageHeader
        ghost={false}
        // extra={[
        //   <RevxButton
        //     key="create"
        //     type="primary"
        //     onClick={() => {
        //     }}
        //   >
        //     {t('platform.tf.labels.testButton')}
        //   </RevxButton>,
        // ]}
      />
      <Space direction="vertical" style={{ width: '100%' }}>
        <Title>{t('platform.tf.labels.defaultSectionTitle')}</Title>
        <RevxFlexLayout justify="space-between">
          <SubHeading>
            {t('platform.tf.labels.defaultSectionSubTitleOrg')}
          </SubHeading>
          <RevxButton
            key="createDefault"
            type="primary"
            onClick={onDefaultsAdd}
            size="middle"
          >
            {t('common.create')}
          </RevxButton>
        </RevxFlexLayout>
        <TfTable
          data={genericDefaults}
          onItemView={(record) => dispatch.tf.setState({ curItem: record })}
        />
        <Title>{t('platform.tf.labels.exceptionSectionTitle')}</Title>
        <RevxFlexLayout justify="space-between">
          <SubHeading>
            {t('platform.tf.labels.exceptionSectionSubTitle')}
          </SubHeading>
          <RevxButton
            key="createException"
            type="primary"
            onClick={onExceptionsAdd}
          >
            {t('common.create')}
          </RevxButton>
        </RevxFlexLayout>
        <TfTable
          data={genericExceptions}
          onItemView={(record) => dispatch.tf.setState({ curItem: record })}
        />

        {curItem && <TfItemForm />}
      </Space>
    </>
  );
};

export default TfAdmin;
